export const hasSelectedPetInCabin = (pets, trip) => {
    let selections = pets.map(p => p.selectedAccommodation);
    let tripAccommodations = trip.petAccommodations;
    const selectedAccommodations = selections.map(code => tripAccommodations.find(a => a.abbr === code) || {});
    return selectedAccommodations.some(accommodation => accommodation.isPetInCabin);
}